export default __webpack_public_path__ + "static/media/cloud.94b3dd51.svg";